import { ADD_PRODUCTS } from '../action-list'

export const addProducts = (products) => ({
  type: ADD_PRODUCTS,
  products,
})
